module.exports = __webpack_public_path__ + "static/media/trasmetalCert.f560edca.jpg";